const whiteListUsers = [
  'ajay@hexacoder.com',
  'sheaw@modularclosets.com',
  'jerryr@modularclosets.com',
  'chayar@modularclosets.com',
  'nandini.chandragowda@wtioutsourcing.com',
  'maheshwari.beluvigi@wtioutsourcing.com',
  'saras@modularclosets.com',
];
const excludedUsers = ['krishna@hexacoder.com', 'nevil@hexacoder.com'];

export const sentryEnvironment = import.meta.env.MODE;

// For local environment update DEFAULT_BACKEND_URL to http://localhost:3000 or whatever you want
export const DEFAULT_BACKEND_URL =
  import.meta.env.VITE_API_URL ??
  'https://ia93nsm4ih.execute-api.us-east-2.amazonaws.com/Prod/api/modular-studio';

//'https://localhost:5000/api/modular-studio';
const WHITELIST_BACKEND_URL =
  'https://tdyhxnkk8k.execute-api.us-east-2.amazonaws.com/Prod/api/modular-studio';

export const environment = import.meta.env.VITE_ENVIRONMENT;
export const isProd = environment === 'prod' || environment === 'main';
export const isStaging = !isProd;
export const designToolUrl = '/design';
export const takeoffUrl = '/takeoff';
const getUserFromJwt = () => {
  try {
    const key = Object.keys(localStorage).find(
      (k) => k.includes('CognitoIdentityServiceProvider') && k.endsWith('.accessToken'),
    );

    if (!key) return null;

    const token = localStorage.getItem(key);
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const payloadBase64 = parts[1];

    const normalized = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');

    const payloadJson = atob(normalized);
    return JSON.parse(payloadJson);
  } catch (error) {
    console.warn('[JWT Decode Failed]', error);
    return null;
  }
};

const getBackendUrl = () => {
  const user = getUserFromJwt();
  const userEmail = user?.email;

  const isWhiteListed =
    userEmail &&
    (whiteListUsers.includes(userEmail) || userEmail?.toLowerCase()?.endsWith('@hexacoder.com'));

  const isExcluded = excludedUsers.includes(userEmail);
  const url = new URL(window.location.href);
  const isByPass = url.searchParams.get('bypassBackendUrl') === 'true';
  if (isExcluded || isByPass) {
    return DEFAULT_BACKEND_URL;
  }

  if (isProd && isWhiteListed) {
    return WHITELIST_BACKEND_URL;
  }

  return DEFAULT_BACKEND_URL;
};

export const backendUrl = getBackendUrl();
